import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldAlert, Lock, Terminal, ArrowLeft } from 'lucide-react';
import Button from '../components/ui/Button';
import ThemeToggle from '../components/ThemeToggle';

const ForbiddenPage = () => {
  const [showEasterEgg, setShowEasterEgg] = useState(false);
  const [clicks, setClicks] = useState(0);

  const handleShieldClick = () => {
    setClicks(prev => {
      const newClicks = prev + 1;
      if (newClicks === 7) { // Lucky number 7!
        setShowEasterEgg(true);
      }
      return newClicks;
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-purple-500/5">
      <div className="fixed top-0 left-0 right-0 border-b bg-background/80 backdrop-blur-sm z-50">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/">
            <Button variant="ghost" size="sm">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </Link>
          <ThemeToggle />
        </div>
      </div>

      <div className="container mx-auto px-4 pt-32">
        <div className="max-w-2xl mx-auto text-center">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            whileHover={{ rotate: 5 }}
            className="w-24 h-24 mx-auto mb-8 rounded-2xl bg-destructive/10 flex items-center justify-center cursor-pointer"
            onClick={handleShieldClick}
          >
            <ShieldAlert className="w-12 h-12 text-destructive" />
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-7xl font-bold mb-4"
          >
            403
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-2xl font-semibold mb-2"
          >
            Access Forbidden
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-muted-foreground mb-8"
          >
            You don't have permission to access this resource.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <Link to="/">
              <Button size="lg">
                Return Home
              </Button>
            </Link>
          </motion.div>

          <AnimatePresence>
            {showEasterEgg && (
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                className="mt-16 p-6 rounded-lg border bg-card/50 backdrop-blur-sm"
              >
                <Lock className="w-8 h-8 text-primary mx-auto mb-4" />
                <code className="block text-sm font-mono mb-4">
                  <span className="text-green-500">$ </span>
                  Security override accepted! 🔓
                </code>
                <p className="text-sm text-muted-foreground">
                  You've found the secret override! Just like how we keep your code snippets secure,
                  some secrets are meant to be discovered. Keep clicking that shield!
                </p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default ForbiddenPage;